var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
var DateTimePipe = /** @class */ (function (_super) {
    __extends(DateTimePipe, _super);
    function DateTimePipe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateTimePipe.prototype.transform = function (value) {
        return _super.prototype.transform.call(this, +value * 1000, 'yyyy-MM-dd HH:mm O');
    };
    return DateTimePipe;
}(DatePipe));
export { DateTimePipe };



// WEBPACK FOOTER //
// ./src/app/access-management/date-time.pipe.ts.pre-build-optimizer.js